module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Articles","add":"Add new batch"}}')
  delete Component.options._Ctor
}
